import type { FaireProductEntity } from "../../entity_types/product";

export const p_ux6xxmrjuw: FaireProductEntity = {
  token: "p_ux6xxmrjuw",
  type: "product",
  name: "Honey Bee Crew Socks",
  brandToken: "b_46c570c5",
  brandName: "Solmate Socks",
  imageUrl:
    "https://cdn.faire.com/fastly/c4d44958db0cacb736cc1db81b17859c85513d347495b96b7291970add9ea058.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9c2a696583227c00161a2b5cc75df71108e2f0a97e7edf94f6be83d4bdf8c70f.jpeg",
    "https://cdn.faire.com/fastly/05e2dfd46e90ab13dc960d2994ff961f537eea752aa5a6dc39f7dc49b90b4a79.jpeg",
    "https://cdn.faire.com/fastly/8f040ea8f2814cd2b78a9b8c651654834f939c159ef5098e4c29168480ced580.jpeg",
    "https://cdn.faire.com/fastly/342609dc0af84dc3c5ab138f5ef10735742775202c468f1afabf803ab78ed19d.jpeg",
    "https://cdn.faire.com/fastly/b0ccb15cbf8191ad43d4bed76b54620e49b8aec98912231aa51f401014b68e1f.jpeg",
    "https://cdn.faire.com/fastly/2a39b69adf831a78523e748d6302fec9f943ffc93b62308064930df5d8f663a0.jpeg",
  ],
  priceDollars: 9.25,
  description:
    "\nDedicated to supporting one of our favorite pollinators - the honey bee! 5% of all sales from these socks will be donated to Pollinator Partnership, a non-profit whose mission is to promote the health of pollinators, critical to food and ecosystems, through conservation, education, and research. Signature initiatives include the North American Pollinator Protection Campaign, National Pollinator Week, and the Eco-regional Planting Guides. Colors in this sock: Black, Caramel Brown, Beige, Honey Mustard, and Ivory.\n\nMade With: 62% Recycled Cotton, 22% Recycled Polyester, 15% Nylon, 1% Spandex ",
  tags: [],
  msrpDollars: 19.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:30.381Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
